export default "<p>\r\n  delete-user works!\r\n</p>\r\n"